import MessageHelper from '../../helpers/message-helper';
import QuantitySelector from '../inputs/quantity-selector';

export default class DirectDeliveryStockMessage {
  private label: JQuery<HTMLParagraphElement>;

  constructor(private container: JQuery<HTMLElement>) {
    this.label = container.find('p');
    this.bindQuantitySelector();
  }

  static initAll(): DirectDeliveryStockMessage[] {
    return Array.from(
      document.querySelectorAll<HTMLElement>('.js-directDeliveryStockMessage'),
    ).map((el) => new DirectDeliveryStockMessage($(el)));
  }

  private bindQuantitySelector(): void {
    const productCode = this.container.data('product-code') as string;
    if (!productCode) return;

    const quantityInput = QuantitySelector.getInputForProductCode(productCode);
    quantityInput?.on('change check', (event) => {
      const input = $(event.target);
      const value = Number.parseInt(input.val() as string, 10);
      const max = Number.parseInt(input.data('max'), 10);
      if (max && value >= max) {
        if (max === 1) {
          this.label.text(MessageHelper.getMessage('eparts.product.directDeliveryStockAvailability'));
        } else {
          this.label.text(MessageHelper.getMessageWithAttributes('eparts.product.directDeliveryStockAvailability.plural', max));
        }
        this.container.removeClass('d-none');
      }
    });
  }
}
